import { Link, useNavigate } from "react-router-dom";
import { Phone, LogOut, MessageCircle } from "lucide-react";
import { auth } from "@/lib/api";
import NotificationBell from "@/components/NotificationBell";
import { waLink } from "@/components/WhatsAppButton";

export const Navbar = ({ variant = "landing" }) => {
  const navigate = useNavigate();
  const role = auth.getRole();
  const user = auth.getUser();

  const logout = () => {
    auth.clear();
    navigate("/");
  };

  const isLanding = variant === "landing";

  return (
    <nav
      className={
        isLanding
          ? "glass-nav fixed top-0 left-0 right-0 z-40"
          : "bg-white border-b border-[#E5E3DB]"
      }
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2"
          data-testid="navbar-logo-link"
        >
          <img
            src="/octa-logo.png"
            alt="OCTA Services"
            className="w-10 h-10 rounded-xl object-cover"
          />
          <span className="font-display text-xl tracking-tight">
            OCTA <span className="text-[#E06D53]">Services</span>
          </span>
        </Link>

        <div className="flex items-center gap-3">
          <a
            href="tel:9015334444"
            className="hidden md:flex items-center gap-2 text-sm text-[#1A1A1A] font-medium hover:text-[#E06D53]"
            data-testid="navbar-helpline"
          >
            <Phone className="w-4 h-4" />
            9015334444
          </a>
          <a
            href={waLink(null, "Hi OCTA, I need help.")}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex h-10 px-3 rounded-full items-center gap-1.5 bg-[#25D366] text-white text-xs font-semibold hover:bg-[#1EBE5C]"
            data-testid="navbar-whatsapp"
          >
            <MessageCircle className="w-4 h-4" /> WhatsApp
          </a>

          {!role && (
            <>
              <Link
                to="/partner/login"
                className="hidden md:inline-flex h-10 px-4 rounded-full border border-[#E5E3DB] items-center text-sm font-medium hover:bg-[#F3F1ED]"
                data-testid="navbar-partner-login"
              >
                Partner Login
              </Link>
              <Link
                to="/customer/login"
                className="inline-flex h-10 px-5 rounded-full btn-accent items-center text-sm font-semibold"
                data-testid="navbar-customer-login"
              >
                Book Service
              </Link>
            </>
          )}

          {role && (
            <>
              {(role === "customer" || role === "partner") && <NotificationBell />}
              <span className="hidden md:block text-sm text-[#4A4A4A]">
                {user?.name || role}
              </span>
              <button
                onClick={logout}
                className="inline-flex h-10 px-4 rounded-full border border-[#E5E3DB] items-center gap-2 text-sm font-medium hover:bg-[#F3F1ED]"
                data-testid="navbar-logout"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
